import React, {useRef, useState} from 'react';
import {DatePicker, Input, PageHeader, Space, Select, Button} from 'antd';

import {PageGrid} from '@/component';
import {getColumns} from './jobLogsColumns';
import {FileOutlined} from '@/icons';
import {getEndTimestamp, getStartTimestamp} from '@/util/dateUtils';
import JobLogInfoModal from './JobLogInfoModal';

const {Option} = Select;

export default function JobLogsList() {
    const tableRef = useRef();
    const logInfoModalRef = useRef();

    const [status, setStatus] = useState(null);
    const [jobName, setJobName] = useState(null);
    const [jobGroup, setJobGroup] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    //查看详情
    function onViewClick(record) {
        logInfoModalRef.current.showModal(record.jobLogId);
    }

    function onStatusChange(value) {
        setStatus(value);
    }

    function onJobNameChange({target: {value}}) {
        setJobName(value);
    }

    function onJobGroupChange(value) {
        setJobGroup(value);
    }

    function onStartDateChange(date) {
        setStartDate(date);
    }

    function onEndDateChange(date) {
        setEndDate(date);
    }

    function onSubmit() {
        const begin = startDate && getStartTimestamp(startDate);
        const end = endDate && getEndTimestamp(endDate);
        const params = {
            status: status,
            jobName: jobName,
            jobGroup: jobGroup,
            begin: begin,
            end: end,
        };
        tableRef.current.reload2FirstPage(params);
    }

    function onReset() {
        setStatus(null);
        setJobName(null);
        setJobGroup(null);
        setEndDate(null);
        setStartDate(null);
        tableRef.current.reload2FirstPage({});
    }

    const columns = getColumns([
        'jobLogId',
        'jobId',
        'jobName',
        'jobGroup',
        'invokeTarget',
        'jobMessage',
        'status',
        'createTime',
    ]);

    columns.push({
        title: '操作',
        key: 'action',
        width: 100,
        render: (text, record) => (
            <Button type="link" icon={<FileOutlined />} onClick={() => onViewClick(record)}>
                查看详细
            </Button>
        ),
    });

    function renderExtra() {
        return (
            <Space>
                <Input placeholder="任务名称" value={jobName} onChange={onJobNameChange} />
                <Select value={jobGroup} style={{width: 120}} onChange={onJobGroupChange}>
                    <Option value={null}>任务组名</Option>
                    <Option value="DEFAULT">默认</Option>
                    <Option value="SYSTEM">系统</Option>
                    <Option value="MEDIA">图文</Option>
                </Select>
                <Select value={status} style={{width: 120}} onChange={onStatusChange}>
                    <Option value={null}>状态</Option>
                    <Option value="0">成功</Option>
                    <Option value="1">失败</Option>
                </Select>
                <DatePicker placeholder="起始时间" value={startDate} onChange={onStartDateChange} />
                <DatePicker placeholder="截止时间" value={endDate} onChange={onEndDateChange} />
                <Button type="primary" onClick={onSubmit}>
                    搜索
                </Button>
                <Button onClick={onReset}>重置</Button>
                <Button type="primary" onClick={onSubmit}>
                    刷新
                </Button>
            </Space>
        );
    }

    return (
        <div style={{flex: 'auto', flexDirection: 'row'}}>
            <PageHeader title="日志列表" extra={renderExtra()} />
            <div style={{margin: '0 24px 24px'}}>
                <PageGrid ref={tableRef} url={'/jobLogs'} columns={columns} rowKey="jobLogId" />
            </div>
            <JobLogInfoModal ref={logInfoModalRef} modalTitle="日志详细" />
        </div>
    );
}
